import config from "./../config.json"
import { gameUpdateStage } from "../entities/ui/actions"
import { browserHistory } from "react-router"

import {
  gameUpdateShowForeplayResults,
  gameUpdateShowResults,
  gameChangeRevealedFlag,
  gameOnAnswerStatsReset,
  refreshGameAnswerStats,
  refreshForeplayStats,
  refreshPlayerList,
  disableForeplay,
  endForeplay,
  gameUpdateLog,
  checkForDraw,
  startGame,
  refreshGame,
  endGame,
  joinGame,
} from "../entities/game/actions"

import { store } from "../index"

let socket
let shouldReconnect = true
let answerBuffer = { answers: [], isUpdate: false }

const Socket = {
  /**
   * Connect to Socket
   * @param {string} gameId
   * @param {object} user
   */
  async createSocket(gameId) {
    if (socket) {
      return
    }

    socket = new WebSocket(config.socketUrl)

    let disconnectAlert = false
    socket.onerror = (err) => {
      if (!disconnectAlert) {
        console.log("Oops!", "It looks like you've been disconnected.")
        disconnectAlert = true
      }
      console.error("Connection Failed", err)
    }

    /**
     * Join tv app to game
     */
    socket.onopen = () => {
      socket.send(
        JSON.stringify({
          apiEvent: "join_room",
          gameId,
          isAdmin: false,
          isTv: true,
        })
      )
    }

    setInterval(() => {
      const { answers, isUpdate } = answerBuffer
      if (answers.length > 0) {
        store.dispatch(refreshGameAnswerStats({ answers, isUpdate }))
      }
      answerBuffer = {
        answers: [],
        isUpdate: false,
      }
    }, 1000)

    /**
     * Receive Event:
     * @param {object} event
     * @return {void}
     */
    socket.addEventListener("message", (event) => {
      const payload = JSON.parse(event.data) || {}

      /**
       * Trigger interface update for all players when the game starts
       * @param {object} payload
       */
      if (payload.event === "game_start") {
        store.dispatch(startGame())
        store.dispatch(disableForeplay())
        store.dispatch(refreshGame(payload))
      }

      if (payload.event === "game_end") {
        store.dispatch(endGame())
      }

      /**
       * Trigger player's list update after
       * players join or leave a game
       */
      if (payload.event === "player_list_update") {
        store.dispatch(refreshPlayerList(payload))
      }

      /**
       * Update the answer stats
       * - Runs on every answer submission
       */
      if (payload.event === "answer_stats_update") {
        // store.dispatch(refreshGameAnswerStats(payload))
        answerBuffer = {
          ...payload,
          answers: [...answerBuffer.answers, ...payload.answers],
        }
      }

      if (payload.event === "game_currentstage_update") {
        store.dispatch(refreshGame(payload))
      }

      /**
       * Update players interface when reveling the foreplay answers
       * Triggered when host navigates through the foreplay answers
       */
      if (payload.event === "game_foreplay_update") {
        store.dispatch(refreshForeplayStats(payload))
      }

      /**
       * Update players interface when the foreplay ends.
       * Trigged when the host revealed all answers for the foreplay.
       */
      if (payload.event === "game_foreplay_end") {
        store.dispatch(gameUpdateStage("startWindow"))
        store.dispatch(endForeplay())
      }

      if (payload.event === "showForeplayResults") {
        store.dispatch(gameUpdateShowForeplayResults(true))
      }

      if (payload.event === "showResultsForQuestion") {
        store.dispatch(gameUpdateShowResults(true))
      }

      if (payload.event === "answer_reveal_choicepoll") {
        store.dispatch(refreshGameAnswerStats(payload))
        store.dispatch(gameUpdateShowResults(true))
        store.dispatch(checkForDraw())
      }

      if (payload.event === "answer_reveal_voicepoll") {
        store.dispatch(gameChangeRevealedFlag(1))
      }

      if (payload.event === "answer_reveal_sequencepoll") {
        store.dispatch(refreshGameAnswerStats(payload))
        store.dispatch(gameUpdateShowResults(true))
      }

      if (payload.event === "answer_reveal_eliminationpoll") {
        store.dispatch(refreshGameAnswerStats(payload))
        store.dispatch(gameUpdateShowResults(true))
        store.dispatch(checkForDraw())
      }

      if (payload.event === "answer_stats_reset") {
        store.dispatch(gameOnAnswerStatsReset(payload.log))
      }

      if (payload.event === "coin_flipped_result") {
        store.dispatch(gameUpdateLog(payload))
      }
    })

    /**
     * In connection close
     */
    socket.onclose = () => {
      this.reconnect()
    }
  },

  /**
   * Reconnect to websocket
   */
  async reconnect() {
    socket = false

    const location = browserHistory.getCurrentLocation()
    const gameId = location.pathname.replace("/", "").trim()

    if (gameId && shouldReconnect) {
      store.dispatch(joinGame({ game_id: gameId }))
    }
  },

  /**
   * Check if socket exists
   */
  isSocket() {
    return socket ? true : false
  },

  /**
   * Get the socket connection
   */
  getSocket() {
    return socket
  },

  /**
   * Close the socket connection
   */
  closeSocket() {
    if (!socket) {
      return
    }
    shouldReconnect = false
    socket.close()
    socket = null
  },
}

export default Socket



// WEBPACK FOOTER //
// ./src/lib/socket.js